var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2609 52.0019C47.7442 52.0019 53 46.7462 53 40.2628C53 33.7795 47.7442 28.5237 41.2609 28.5237C34.7775 28.5237 29.5217 33.7795 29.5217 40.2628C29.5217 46.7462 34.7775 52.0019 41.2609 52.0019Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4106 36.1111L37.1111 44.4126",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4106 44.4126L37.1111 36.1111",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7563 26.5202C48.9694 25.5715 49.0803 24.6027 49.087 23.6304C49.087 14.4485 39.8913 7 28.5435 7C17.1957 7 8 14.4485 8 23.6304C8.10313 28.2104 10.274 32.4976 13.9048 35.2913L9.95652 44.1739L20.9854 39.087C22.4947 39.5616 24.0462 39.8892 25.6185 40.0652",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatUnavailable);
export default __webpack_public_path__ + "static/media/icon-chat-unavailable.abeae789.svg";
export { ForwardRef as ReactComponent };